/**
 * AI礼包管理器
 */
const Event = require("cocos/framework/components/event")
const { AIPkgType, AIDCType, AIPayType} = require("./AIPkgConst")
const dcUtil = require("entry/dc")
const IslandBookManager = require("clover/scene/component/homescene/IslandBook/IslandBookManager")

let AIPkgManager = xClass("AIPkgManager", Event)

const MngrEvents = AIPkgManager.Events = {
    kDailyPkgHttpEnd: "AIPM_EVT_DAILY_PKG_HTTP_END", // 请求每日特惠礼包完成
    kRevivePkgHttpEnd: "AIPM_EVT_REVIVE_PKG_HTTP_END",   //请求关末礼包完成
    kDailyPkgClear: "AIPM_EVT_DAILY_PKG_CLEAR", // 清空每日礼包，可能因为购买/到期等原因
    kRevivePkgClear: "AIPM_EVT_REVIVE_PKG_CLEAR", // 清空复活礼包，可能因为关闭复活界面等原因
    kRevivePkgBought: "AIPM_EVT_REVIVE_PKG_BOUGHT", // 清空礼包购买标识设为true，可能因为在商店被购买
}

const PackageStatus = {
    Unload: 0, // 没有加载成功
    Loading: 1,    // 加载中
    Loaded: 2, // 加载完成
}

const STORAGE_KEY = "_local_storage_ai_pkg"
const STORAGE_VER = "1";

const MAX_START_RETRY = 3;

let _instance;
AIPkgManager.getInstance = function () {
    if (!_instance) {
        _instance = AIPkgManager.create();
    }
    return _instance;
}

/**
 * 判断一个id是否为ai礼包
 * @param {*} id 
 */
AIPkgManager.IsAiPackage = function (id) {
    id = id * 1
    return !isNaN(id) && id >= 6000000 && id <= 7999999
}
AIPkgManager.prototype.ctor = function () {
    let self = this;

    self.config = null; // 规则配置
    self.storage = null; // 本地缓存

    self.bind(self);

    self._dailyPkg = null;   // 每日特惠礼包缓存数据
    self._revivePkg = null; // 复活礼包缓存数据
    self._dc4ABTest = false;    // 是否打过abTest分组点位
    self._dailyPkgStatus = PackageStatus.Unload;  // 每日礼包加载情况
    self._revivePkgReqTime = 0;  // 请求复活礼包的时间戳

    self._netType = null;  // 缓存的网络类型，用于发送实时特征值
    self._levelHighTry = null; // 缓存的最高关打关次数，用于发送实时特征值

    self._showDcData = null;  // 缓存的打点数据，用于useracion_payment打点

    startNetWorkMonitor(self);
    startLevelHighMonitor(self);

    // 控制启动次数，超出次数不再启动AI
    self._startRetry = 0;
    self._isStartBusy = false;
    
    // 监听场景更换，用于尝试启动自身、以及退出游戏场景时清空复活礼包
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kOneSceneEnter, 
        function() {
            self.clearRevivePackages();
            self.start();
        }
    );
}
const AI_DELAY_TIME = 0;//ai 礼包延迟值

/**
 * 启动AI礼包管理器
 */
AIPkgManager.prototype.start = function () {
    let self = this;
    
    if (self.isRunning() || self._startRetry > MAX_START_RETRY || self._isStartBusy) { 
        return;
    }

    if (__DEBUG) {
        if (typeof MetaManager.getInstance().supportCash !== "boolean") {
            throw new Error("AIPkgManager cannot start before MetaManager initialized");
        }
    }

    self._isStartBusy = true;
    
    Promise.all([CfgManager.load("aipackage_settings", "aipackage","ai_daily_bind_package"), loadTestGroupInfoPromise()])
    .then(dataMap => {
        let req = dataMap[1] && dataMap[1].data || { aiTestGroup: "", aiGroup: false, testId: "", testName: "" }
        let config = CfgManager.get("aipackage_settings");
        let packages = CfgManager.get("aipackage");
        self.bindPackage = CfgManager.get("ai_daily_bind_package");
        CfgManager.release("aipackage_settings", "aipackage","ai_daily_bind_package"); 

        let aiGroup = req.aiTestGroup;
        let groupOn = req.aiGroup.toString().toLowerCase() === "true"
        let snsProxy = require("clover/sns/SnsProxy").getInstance();
        let platformSwitch = config.ai_package_platform_switch.match(new RegExp(`${snsProxy.getPlatformName()}\:\{[\\w,]+`));
        let switchAry = null;
        if (platformSwitch && typeof platformSwitch[0] === "string") {
            switchAry = platformSwitch[0].replace(`${snsProxy.getPlatformName()}\:\{`, "").toLowerCase().split(",");
        } else {
            switchAry = [];
        }
        let supportCash = MetaManager.isSupportCash();
        self.config = {
            needDC: __DEV || (window.mini && mini.getPlatform() === MiniPlatform.wechatGame),  // 是否允许打ai相关点位
            aiGroup: aiGroup,
            // 四个显示位是否显示标识
            dailyOn: groupOn && supportCash && switchAry.indexOf("daily") >= 0,
            reviveOn: groupOn && supportCash && switchAry.indexOf("stage") >= 0,
            shopDailyOn: groupOn && supportCash && switchAry.indexOf("daily_in_shop") >= 0,
            shopReviveOn: groupOn && supportCash && switchAry.indexOf("stage_in_shop") >= 0,
            // 玩家等级开关
            lvLimit: string2Number(config.ai_package_open_level, 0),
            // 在商店内显示的优先级
            shopDailyPrio: string2Number(config.ai_package_daily_priority, 0),
            shopRevivePrio: string2Number(config.ai_package_stage_priority, 0),
            // 复活礼包可借接受的网络请求时间
            reviveReqTime: string2Number(config.ai_package_request_time, 0) * 1000,
            // 每日礼包持续时间（秒）
            dailyDuration: string2Number(config.ai_package_daily_countdown_time, 0) * 60 * 60,
            // 礼包详情
            packages,
            
            // 正交分组信息
            testId: req.testId,
            testName: req.testName
        }
        if (__DEV) {
            self.config.dailyOn = true;
            self.config.reviveOn = true;
            self.config.shopDailyOn = true;
            self.config.shopReviveOn = true;
        }
        self.storage = readStorage();

        checkDC4ABTest(self);

        self.collectUserAiStartTime = new Date().getTime();//初始时间 为了后面延迟提交收集数据
        // 延迟500ms获取每日礼包，否则网络类型还未获取到
        if (self.isDailyOn()) {
            setTimeout(function () { 
                verifyDailyPackage(self); 
                self.collectUserAiInfo();
            }, AI_DELAY_TIME);
        }else {
            setTimeout(function () { 
                self.collectUserAiInfo();
            }, AI_DELAY_TIME);
        }

        // 开始监听订单号生成， 用于打点
        GlobalEventDispatcher.getInstance().addEventListener(
            kGlobalEvents.kOneOrderGenerate, 
            function(evtData) {
                if (self._showDcData && evtData && evtData.data && evtData.data.orderId)
                    self._showDcData.orderId = evtData.data.orderId;
            }
        );

        // cc.log("[AI Package]", "Manager start success.", JSON.stringify({
        //     config: self.config,
        //     stroage: self.storage,
        //     netType: self._netType,
        //     lvHigh: self._levelHighTry
        // }));
    })
    .catch(err => {
        cc.error("[AI Package]", "load config fail.", err);
        self._isStartBusy = false;
        self._startRetry = self._startRetry + 1;
    })
}

/**
 * 是否正在运行中
 * 没有加载到ai礼包参数配置无法启动
 */
AIPkgManager.prototype.isRunning = function () {
    let self = this;
    self.dcReturnType = self.config != null ? self.dcReturnType : "20"
    return self.config != null;
}

AIPkgManager.prototype.isStartBusy = function () {
    let self = this;
    return !self.isRunning() && self._isStartBusy;
}

/**
 * 当前是否可以开启每日礼包
 */
AIPkgManager.prototype.isDailyOn = function () {
    let self = this;
    return self.isRunning() && self.config.dailyOn && checkUserLevel(self);
}

/**
 * 获取当前缓存的每日礼包
 * @param vertifyPeriod: boolean = false    是否需要校验有效期。如果为true，礼包过期情况下返回null
 */
AIPkgManager.prototype.getDailyPackage = function (vertifyPeriod = false) {
    let self = this;
    
    if(!self.isDailyOn())
        return null;

    if (!self._dailyPkg)
        return null;

    return !vertifyPeriod || self._dailyPkg.period > Localhost.time()? self._dailyPkg: null;
}

/**
 * 获取礼包所属类型
 * @param {*} packageId 
 */
AIPkgManager.prototype.getPackageType = function (packageId) {
    let self = this;

    let dailyPkg = self.getDailyPackage();
    let id = self.getLeaderId(packageId);
    if (dailyPkg && (dailyPkg.package_id == id))
        return AIPkgType.Daily;
    else 
        return AIPkgType.Revive;
}
/**
 * 如果当前没有每日礼包数据，进行一次请求
 * @param {*} onComplete 
 */
AIPkgManager.prototype.fetchDailyPackage = function (onComplete) {
    let self = this;

    if (!self.isDailyOn()) {
        onComplete && onComplete(null);
        return;
    }

    verifyDailyPackage(self);

    if (self._dailyPkgStatus === PackageStatus.Loading) {
        if (onComplete) {
            self.once(MngrEvents.kDailyPkgHttpEnd, function (){
                onComplete(self.getDailyPackage());
            });
        }
    } else {
        onComplete && onComplete();
    }
}

/**
 * 如果每日礼包的状态为加载完成，那么将礼包清除
 */
AIPkgManager.prototype.clearDailyPackageIfLoaded = function () {
    let self = this;
    if (self.isRunning()) {
        if (self._dailyPkgStatus === PackageStatus.Loaded) {
            let hasDailyPkgOrg = self._dailyPkg != null;
            self._dailyPkg = null;

            if (hasDailyPkgOrg) {
                self.dispatchEvent({name: MngrEvents.kDailyPkgClear})
            }
        }
    }
}

/**
 * 今天是否弹出过每日特惠面板
 */
AIPkgManager.prototype.hasPopDailyToday = function () {
    let self = this;
    return self.storage.lastDailyPop == Localhost.timeInDay();
}

/**
 * 标记每日特惠面板弹出
 */
AIPkgManager.prototype.markDailyPop = function () {
    let self = this;
    
    self.storage.lastDailyPop = Localhost.timeInDay();
    writeStorage(self.storage);    
}

/**
 * 获取礼包配置
 * @param {*} packageId 
 */
AIPkgManager.prototype.getPackageMeta = function (packageId) {
    let self = this;

    if (!self.isRunning()){
        return null;
    }

    if(self.config.packages[packageId]) {
        return self.config.packages[packageId]
    }else {
        let cfg = self.bindPackage[packageId] || {};
        if(typeof cfg.items === 'string') {
            let str = cfg.items;
            let arr = str.split(",");
            let items = {};
            for (let i = 0; i < arr.length; i++) {
                let arr1 = arr[i].split(":");
                items[Number(arr1[0])] = Number(arr1[1]);
            }
            cfg["items"] = items;
        }
        return cfg;
    }
}


/**
 * 当前是否可以开启复活礼包
 */
AIPkgManager.prototype.isReviveOn = function () {
    let self = this;

    if (self.config){
        self.dcReturnType =  self.config.reviveOn ? self.dcReturnType : "21"

    }
    return self.isRunning() && self.config.reviveOn && checkUserLevel(self);
}

/**
 * 是否正在加载复活礼包
 */
AIPkgManager.prototype.isLoadingRevivePackages = function () {
    let self = this;
    if (!self.isReviveOn())
        return false;

    self.dcReturnType = (self._revivePkgReqTime > 0) ? "24" : self.dcReturnType

    return self._revivePkgReqTime > 0;
}

/**
 * 开始加载复活礼包
 */
AIPkgManager.prototype.loadRevivePackages = function (mainLogic) {
    let self = this;
    self.dcCallnfoHttp = false
    self.dcInfoHttpResult = "unknown"
    self.dcReturnType = ""
    
    // self.dcReturnType = (mainLogic && mainLogic.levelType == GameLevelType.kMainLevel) ? self.dcReturnType : "23"
    if (!self.isReviveOn() 
        || mainLogic == null 
        )    // 目前只有主线关卡支持ai复活礼包
        return;

    self._revivePkg = null;
    self.removeEventListenersByEvent(MngrEvents.kRevivePkgHttpEnd);
    self._revivePkgReqTime = Localhost.time();

    let reqTime = self._revivePkgReqTime;
    function onFail(evt) {
        if (reqTime === self._revivePkgReqTime) {
            cc.warn("[AI Package]", "request ai revive package failed.", evt);
            self._revivePkgReqTime = 0;
            self.dispatchEvent({ name: MngrEvents.kRevivePkgHttpEnd });
            self.dcInfoHttpResult = "fail"
        }else {
            self.dcInfoHttpResult = "fail_unequal"
        }
    }

    function onSuccess(evt) {
        if (reqTime === self._revivePkgReqTime) {
            self._revivePkg = parseRevivePkg(self, evt.data);
            cc.log("[AI Packages]", "get revive package success.", self._revivePkg);
            self.dcReturnType = evt.data.failCode
            self._revivePkgReqTime = 0;
            self.dispatchEvent({ name: MngrEvents.kRevivePkgHttpEnd });
            self.dcInfoHttpResult = "success"
        }else {
            self.dcInfoHttpResult = "success_unequal"
        }
    }

    function outOfTime() {
        if (reqTime === self._revivePkgReqTime) {
            cc.warn("[AI Package]", "request ai revive package out of time.");
            self._revivePkgReqTime = 0;
            self.dispatchEvent({ name: MngrEvents.kRevivePkgHttpEnd });
            self.dcInfoHttpResult = "outoftime"
        }else {
            self.dcInfoHttpResult = "outoftime_unequal"
        }
    }

    // 处理百分比保留两位小数
    let factor = Math.round(mainLogic.gameMode.getStepLevelFactor() * 10000);
    factor = 10000 - factor;
    factor = factor / 100;

    let param = packGetReq(self, AIPkgType.Revive, {
        levelID: mainLogic.level,
        targetPercent: factor
    });
    let http = AIGetDailyPackageHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(param);
    self.dcCallnfoHttp = true
    // setTimeout(outOfTime, self.config.reviveReqTime);
}

/**
 * 获取复活礼包
 */
AIPkgManager.prototype.getRevivePackages = function () {
    let self = this;
    
    if (!self.isReviveOn() || self.isLoadingRevivePackages())
        return null;

    return self._revivePkg;
}

/**
 * 将复活礼包标识为已购买
 */
AIPkgManager.prototype.setRevivePkgBought = function(pkgId) {
    let self = this;

    let revivePkgs = self.getRevivePackages();
    if (!revivePkgs)
        return;

    let list = revivePkgs.list;
    for(let i = 0; i < list.length; i++) {
        if (list[i].package_id == pkgId && !list[i].bought) {
            list[i].bought = true;

            self.dispatchEvent({ name: MngrEvents.kRevivePkgBought, index: i});
            break;
        }
    }
}
/**
 * 是否请求ai礼包
 */
AIPkgManager.prototype.getDcCallInfoHttp = function () {
    let self = this;
    return self.dcCallnfoHttp
}
/**
 * 请求结果
 */
AIPkgManager.prototype.getDcInfoHttpResult = function () {
    let self = this;
    return self.dcInfoHttpResult
}
/**
 * 请求结果
 */
AIPkgManager.prototype.getDcReturnType = function () {
    let self = this;
    
    return self.dcReturnType 
}
/**
 * 清除复活礼包
 */
AIPkgManager.prototype.clearRevivePackages = function () {
    let self = this;

    if (self.isReviveOn()) {
        let hasRevivePkgOrg = self._revivePkg != null;
        self._revivePkg = null;
        self.removeEventListenersByEvent(MngrEvents.kRevivePkgHttpEnd);
        self._revivePkgReqTime = 0;
        
        if (hasRevivePkgOrg) {
            self.dispatchEvent({name: MngrEvents.kRevivePkgClear})
        }
    }
}

/**
 * 当前是否可以在商店中展示
 */
AIPkgManager.prototype.isShopOn = function () {
    let self = this;
    return self.isRunning() && checkUserLevel(self) && (self.config.shopDailyOn || self.config.shopReviveOn);
}

/**
 * 进行曝光打点
 * 曝光->点击->购买->结束曝光为一个周期
 * 用于表useraction_payment，category = package_apply
 */
AIPkgManager.prototype.dcShow = function(dcType, extraData) {
    let self = this;

    if (!self.isRunning() || !self.config.needDC)
        return;
        
    let param = packCommonDCParam(self);
    if (dcType === AIDCType.Daily) {
        if (!self._dailyPkg)
            return;
        fillDCParam4ShowDaily(self, param);
        self._showDcData = param;
    } else if (dcType === AIDCType.Revive){
        if (!self._revivePkg || !extraData)
            return;
        let { packageData } = extraData;
        if (!packageData)
            return;
        fillDCParam4ShowRevive(self, param, packageData);
        self._showDcData = param;
    } else if (dcType === AIDCType.ReviveOther) {
        if (!extraData) 
            return;
        let { showList, seeIndex } = extraData;
        if (!showList)
            return;
        fillDCParam4ShowOtherRevive(self, param, showList, seeIndex || 0);
        self._showDcData = param;
    } else if (dcType === AIDCType.ReviveMarket) {
        // 商店复活不覆盖_showData，因为可能_showData目前缓存了复活礼包的曝光信息
        if (!self._revivePkg || !extraData)
            return;

        let { packageData, exposureId, packagesAll } = extraData;
        fillDCParam4ShowReviveMarket(self, param, packageData, exposureId, packagesAll);
    } else if (dcType === AIDCType.DailyMarket) {
        // 商店每日不覆盖_showData，因为可能_showData目前缓存了复活礼包的曝光信息
        if (!self._dailyPkg || !extraData)
            return;

        let { exposureId, packagesAll } = extraData;
        fillDCParam4ShowDailyMarket(self, param, exposureId, packagesAll);
    }

    DCAssist.dc4ShowAIPackages(param);
    return param;
}


/**
 * 进行翻页打点
 */
AIPkgManager.prototype.dcSwap = function(dcType, extraData) {
    let self = this;
    
    if (!self._showDcData)
        return;

    let param = packCommonDCParam(self);
    let { packageData } = extraData;
    if (!packageData)
        return;
    Object.assign(param, {
        package_see: packageData.package_id,
        exposure_id: self._showDcData.exposure_id,
        packages_show: self._showDcData.packages_show,
        packages_show_all: self._showDcData.packages_show_all,
        actual_use_tag: self._showDcData.actual_use_tag,
        group_tag: self._showDcData.group_tag,
        session: self._showDcData.session,
        current_stage: self._showDcData.current_stage,
        event_id: self._showDcData.event_id,
        algorithm_id: self._showDcData.algorithm_id,
        packages_rec: self._showDcData.packages_rec,        
        request_from: self._showDcData.request_from,
        place_label: self._showDcData.place_label,
        daily_discount_package_first_show: self._showDcData.daily_discount_package_first_show,
        daily_discount_package_id: self._showDcData.daily_discount_package_id,        
        daily_discount_package_duration: self._showDcData.daily_discount_package_duration
    });
    
    DCAssist.dc4SwapAIPackages(param);
}

/**
 * 进行点击打点
 */
AIPkgManager.prototype.dcClick = function(dcType, extraData) {
    let self = this;
    
    let showDcData = self._showDcData;
    if (dcType === AIDCType.DailyMarket || dcType === AIDCType.ReviveMarket) {
        showDcData = extraData? extraData.showDcData: null;
    }
    
    if (!showDcData)
        return;

    let param = packCommonDCParam(self);
    let { packageData } = extraData;
    Object.assign(param, {
        package_click: packageData.package_id,
        buy_type: packageData.payType,
        price: packageData.dcPrice,
        package_see: packageData.package_id,
        
        packages_show_all: showDcData.packages_show_all,

        event_id: showDcData.event_id,
        algorithm_id: showDcData.algorithm_id,
        packages_rec: showDcData.packages_rec,
        packages_show: showDcData.packages_show,
        exposure_id: showDcData.exposure_id,
        actual_use_tag: showDcData.actual_use_tag,
        group_tag: showDcData.group_tag,
        session: showDcData.session,
        current_stage: showDcData.current_stage,
        request_from: showDcData.request_from,
        place_label: showDcData.place_label,
        daily_discount_package_first_show: showDcData.daily_discount_package_first_show,
        daily_discount_package_id: showDcData.daily_discount_package_id,        
        daily_discount_package_duration: showDcData.daily_discount_package_duration
    });
    
    DCAssist.dc4BuyAIPackages(param);
}

/**
 * 进行购买打点
 */
AIPkgManager.prototype.dcPurchase = function(dcType, extraData) {
    let self = this;

    let showDcData = self._showDcData;
    if (dcType === AIDCType.DailyMarket || dcType === AIDCType.ReviveMarket) {
        showDcData = extraData? extraData.showDcData: null;
    }

    if (!showDcData || !showDcData.orderId)
        return;

    let param = packCommonDCParam(self);
    let { packageData, buyResult, seePackageId} = extraData;
    Object.assign(param, {
        package_buy: packageData.package_id,
        buy_type: packageData.payType,
        price: packageData.dcPrice,

        buy_result: buyResult,

        package_see: seePackageId,

        order_id: showDcData.orderId,
        packages_show_all: showDcData.packages_show_all,

        event_id: showDcData.event_id,
        algorithm_id: showDcData.algorithm_id,
        packages_rec: showDcData.packages_rec,
        packages_show: showDcData.packages_show,
        exposure_id: showDcData.exposure_id,
        actual_use_tag: showDcData.actual_use_tag,
        group_tag: showDcData.group_tag,
        session: showDcData.session,
        current_stage: showDcData.current_stage,
        request_from: showDcData.request_from,
        place_label: showDcData.place_label,
        daily_discount_package_first_show: showDcData.daily_discount_package_first_show,
        daily_discount_package_id: showDcData.daily_discount_package_id,        
        daily_discount_package_duration: showDcData.daily_discount_package_duration
    });
   
    DCAssist.dc4PurchaseAIPackages(param);
}

/**
 * 获取或创建商店展示曝光id
 */
AIPkgManager.prototype.getOrGenerateMarketExposureId = function() {
    let self = this;
    if (self.getRevivePackages() && self._showDcData && self._showDcData.exposure_id) {
        return self._showDcData.exposure_id;
    }
    return `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
}

/**
 * 包装通用DC打点数据
 * @param {*} self 
 */
function packCommonDCParam(self) {
    return {
        gameversion: META.version,
        dcsdkver: __AISDK_VER,
        dcsession_id: dcUtil.getDCSession(),
        seq_id: dcUtil.stealSeq(),
        keyword_level: UserManager.getInstance().user.topLevelId,
        client_time: formatDate(new Date()),
        ip:  UserManager.getInstance().location && UserManager.getInstance().location.ip,
        network_state: netType2Rtuf(self._netType)
    }
}
/**
 * 填充每日礼包场景曝光打点参数
 * @param {*} self 
 * @param {*} param 
 */
function fillDCParam4ShowDaily(self, param) {
    Object.assign(param, {
        packages_show: self._dailyPkg.package_id,
        packages_show_all: self._dailyPkg.package_id,
        group_tag: "ai",
        actual_use_tag: "ai",
        package_see: self._dailyPkg.package_id,
        algorithm_id: self._dailyPkg.aiAlg,
        event_id: self._dailyPkg.aiEvt,
        packages_rec: self._dailyPkg.aiRec,
        buy_type: self._dailyPkg.payType,
        price: self._dailyPkg.dcPrice,
        exposure_id: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
        request_from: "main_scene",
        place_label: "main_scene",
        daily_discount_package_first_show: self.hasPopDailyToday()? "no": "yes",
        daily_discount_package_id: self._dailyPkg.package_id,
        daily_discount_package_duration: self._dailyPkg? self.config.dailyDuration: 0,
    });
}

/**
 * 包装关末复活场景曝光打点参数
 * @param {*} self 
 * @param {*} param 
 */
function fillDCParam4ShowRevive(self, param, seePackageData) {
    let ids = [], buyTypes = [], prices = [], pkg = null;
    for(let i = 0; i < self._revivePkg.list.length; i++) {
        pkg = self._revivePkg.list[i];
        ids.push(pkg.package_id);
        buyTypes.push(pkg.payType);
        prices.push(pkg.dcPrice);
    }
    Object.assign(param, {
        packages_show: ids.join("_"),
        packages_show_all: ids.join("_"),
        group_tag: "ai",
        actual_use_tag: "ai",

        session: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session,
        current_stage: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.current_stage,

        algorithm_id: self._revivePkg.aiAlg,
        event_id: self._revivePkg.aiEvt,
        packages_rec: self._revivePkg.aiRec,

        package_see: seePackageData.package_id,

        buy_type: buyTypes.join("_"),
        price: prices.join("_"),

        exposure_id: `${DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session || UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
        request_from: "plus5_step_panel",
        place_label: "plus_steps",
        daily_discount_package_first_show: "no",
        daily_discount_package_id: self._dailyPkg? self._dailyPkg.package_id: "",
        daily_discount_package_duration: self._dailyPkg? self.config.dailyDuration: 0,
    });
}

/**
 * 包装关末复活场景非AI礼包曝光打点参数
 * @param {*} self 
 * @param {*} param 
 */
function fillDCParam4ShowOtherRevive(self, param, showList, seeIndex) {
    let ids = [], buyTypes = [], prices = [], pkg = null;
    for(let i = 0; i < showList.length; i++) {
        pkg = showList[i];
        ids.push(pkg.package_id);
        buyTypes.push(pkg.payType);
        prices.push(pkg.dcPrice);
    }
    Object.assign(param, {
        packages_show: ids.join("_"),
        packages_show_all: ids.join("_"),

        package_see: showList[seeIndex].package_id,

        group_tag: self.isReviveOn()? "ai": "clover",
        actual_use_tag: "clover",

        session: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session,
        current_stage: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.current_stage,

        buy_type: buyTypes.join("_"),
        price: prices.join("_"),

        exposure_id: `${DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session || UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
        request_from: "plus5_step_panel",
        place_label: "plus_steps",
        daily_discount_package_first_show: "no",
        daily_discount_package_id: self._dailyPkg? self._dailyPkg.package_id: "",
        daily_discount_package_duration: self._dailyPkg? self.config.dailyDuration: 0,
    });
}

/**
 * 包装关末复活场景打开商店时的曝光打点参数
 * @param {*} self 
 * @param {*} param 
 * @param {*} packageData 
 * @param {*} exposureId 
 * @param {*} packagesAll 
 */
function fillDCParam4ShowReviveMarket(self, param, packageData, exposureId, packagesAll) {
    let ids = [], buyTypes = [], prices = [], pkg = null;
    for(let i = 0; i < self._revivePkg.list.length; i++) {
        pkg = self._revivePkg.list[i];
        if (!pkg.bought) {
            ids.push(pkg.package_id);
            buyTypes.push(pkg.payType);
            prices.push(pkg.dcPrice);
        }
    }
    if(packagesAll == null) {
        packagesAll = []
    }
    Object.assign(param, {
        packages_show: ids.join("_"),
        packages_show_all: packagesAll.join("_"),
        group_tag: "ai",
        actual_use_tag: "ai",

        session: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session,
        current_stage: DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.current_stage,

        algorithm_id: self._revivePkg.aiAlg,
        event_id: self._revivePkg.aiEvt,
        packages_rec: self._revivePkg.aiRec,

        package_see: packageData.package_id,

        buy_type: buyTypes.join("_"),
        price: prices.join("_"),

        exposure_id: exposureId,
        request_from: "plus5_step_panel",
        place_label: "game_store",
        daily_discount_package_first_show: "no",
        daily_discount_package_id: self._dailyPkg? self._dailyPkg.package_id: "",
        daily_discount_package_duration: self._dailyPkg? self.config.dailyDuration: 0,
    });
}

/**
 * 商店每日礼包场景曝光打点参数
 * @param {*} self 
 * @param {*} param 
 */
function fillDCParam4ShowDailyMarket(self, param, exposureId, packagesAll) {
    if(packagesAll == null) {
        packagesAll = []
    }
    Object.assign(param, {
        packages_show: self._dailyPkg.package_id,
        packages_show_all: packagesAll.join("_"),
        group_tag: "ai",
        actual_use_tag: "ai",
        package_see: self._dailyPkg.package_id,
        algorithm_id: self._dailyPkg.aiAlg,
        event_id: self._dailyPkg.aiEvt,
        packages_rec: self._dailyPkg.aiRec,
        buy_type: self._dailyPkg.payType,
        price: self._dailyPkg.dcPrice,
        exposure_id: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`, // 每日的曝光点总是uid_timestamp,
        request_from: "main_scene",
        place_label: "game_store",
        daily_discount_package_first_show: "no",
        daily_discount_package_id: self._dailyPkg.package_id,
        daily_discount_package_duration: self._dailyPkg? self.config.dailyDuration: 0,
    });
}

/**
 * 处理ABTest分组打点
 * 使用此函数前Manager必须处于Running状态
 * @param {*} self 
 */
function checkDC4ABTest(self) {
    if (!self._dc4ABTest) {
        self._dc4ABTest = true;

        DCAssist.userTrack("abtest", "ai_tag", {
            test_id: self.config.testId,
            test_name: self.config.testName,
            num: self.config.aiGroup,
        });
    }
}

/**
 * 检查玩家当前等级是否可以开启AI礼包功能
 * 是用次函数前Manager必须处于Running状态
 * @param {*} self 
 */
function checkUserLevel(self) {
    self.dcReturnType = UserManager.getInstance().getUserRef().topLevelId >= self.config.lvLimit ? self.dcReturnType : "22"
    return UserManager.getInstance().getUserRef().topLevelId >= self.config.lvLimit;
}


/**
 * 获取网络类型，并监听网络变更
 * @param {*} self 
 */
function startNetWorkMonitor(self) {
    if (window.mini && mini.supportNetStatus()) {
        mini.getNetworkType({
            success: function (res) {
                self._netType = res.networkType;
            }
        });

        mini.onNetworkStatusChange(function (res) {
            self._netType = res.networkType;
        });
    } else if (window.mqq && typeof mqq.device.getNetworkInfo === "function") {
        const _wanbaNetMap = ["none", "wifi", "2g", "3g", "4g"];
        mqq.device.getNetworkInfo(function (res) {
            self._netType = _wanbaNetMap[res.type] || "unknown";
        });
    } else {
        self._netType = "unknown";
    }
}

/**
 * 获取当前最高打关记录，并监听打关记录变更
 * @param {*} self 
 */
function startLevelHighMonitor(self) {
    self._levelHighTry = UserManager.getInstance().levelHighTryTimes;
    if (!self._levelHighTry || !self._levelHighTry.levelId) {
        let tmpScore = UserScore.getScore(UserManager.getInstance().getUserRef().topLevelId);
        self._levelHighTry = {
            levelId: tmpScore.levelId,
            times: tmpScore.updateTime > 0? 1: 0
        }
    }
    let topAttemptScore = UserScore.getScore(self._levelHighTry.levelId);
    self._levelHighTry.star = topAttemptScore.star;

    if (__DEBUG) {
        cc.log("[AI Package]", "get levelHighTry", self._levelHighTry)
    }

    UserLevel.getInstance().on(UserLevelEvent.StartLevel, function (event) {
        if (event.levelId > self._levelHighTry.levelId) {
            // 打新关了，更新最高关全部信息
            self._levelHighTry.levelId = event.levelId;
            self._levelHighTry.times = 0;
            self._levelHighTry.star = 0;
        } else if (event.levelId == self._levelHighTry.levenId && self._levelHighTry.star === 0) {
            // 没有通关过，且仍然打这关，需要更新打关次数
            self._levelHighTry.times = self._levelHighTry.times + 1;
        }
    });
    UserLevel.getInstance().on(UserLevelEvent.WinLevel, function (event) {
        if (event.levelId > self._levelHighTry.levelId) {
            // 打新关了，更新最高关全部信息
            self._levelHighTry.levelId = event.levelId;
            self._levelHighTry.times = 1;
            self._levelHighTry.star = event.star;
        } else if (event.levelId == self._levelHighTry.levenId && self._levelHighTry.star === 0) {
            // 没有通关过，且仍然打这关，需要更新星星数
            self._levelHighTry.star = event.star;
        }
    });
}

/**
 * 检查每日特惠礼包是否存在，如果不存在进行一次网络请求
 * 这个函数不检查每日礼包功能是否开启
 * 每日礼包潜规则：一天最多出现一个每日礼包；因此玩家每次登录只需要成功获取一次每日礼包信息即可
 * @param {*} self 
 */
function verifyDailyPackage(self) {
    if (self._dailyPkgStatus === PackageStatus.Unload) {
        self._dailyPkgStatus = PackageStatus.Loading;

        function onFail(evt) {
            self._dailyPkgStatus = PackageStatus.Unload;
            self._dailyPkg = null;
            cc.warn("[AI Package]", "request ai dailypackage failed.", evt);
            self.dispatchEvent({ name: MngrEvents.kDailyPkgHttpEnd });
        }
        let offsetTime =  new Date().getTime() - self.collectUserAiStartTime;
        if (!self.collectUserAiStartTime || offsetTime < AI_DELAY_TIME ){
            cc.log("[AI Package]", `verifyDailyPackage wait time offsetTime < ${AI_DELAY_TIME}...`,offsetTime);
            //还没过延迟时间 不可以请求
            onFail("未满足延迟时间");
            return;
        }
    
        function onSuccess(evt) {
            self.dailyBindGiftAbGroup = evt.data.dailyBindGiftAbGroup;
            self._dailyPkgStatus = PackageStatus.Loaded;
            self._dailyPkg = parseDailyPkg(self, evt.data);
            cc.log("[AI Packages]","cube is ", self.dailyBindGiftAbGroup);
            cc.log("[AI Packages]", "get daily package success.", self._dailyPkg);
            self.dispatchEvent({ name: MngrEvents.kDailyPkgHttpEnd });
        }

        let param = packGetReq(self, AIPkgType.Daily);
        let http = AIGetDailyPackageHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(param);
    }
}

/**
 * 拼装获取礼包请求豹纹
 * 特征值文档：https://happyelements.atlassian.net/wiki/spaces/HEAI/pages/930578451/Clover+POE+SDK+v0.1
 * @param {*} packageType 
 * @param {*} levelData 
 */
function packGetReq(self, packageType, levelData) {
    cc.log("[AI Package]", "pack request start...")
    let totalStar = UserManager.getInstance().getUserRef().getTotalStar();
    let device = getDeviceInfo();
    let location = UserManager.getInstance().location;
    let day = new Date(Localhost.time()).getDay();

    let param = {
        // type: packageType,
        aiRequest: {
            majorVersion: META.getGameVersion(),
            minorVersion: "",
            sdkVersion: __AISDK_VER,
            rtuf: {
                level_high: self._levelHighTry.levelId,
                level_high_state: self._levelHighTry.star > 0 ? 1 : 0,
                level_high_star: self._levelHighTry.star,
                level_high_try: self._levelHighTry.times,
                level_top_mstage: UserManager.getInstance().getMaxLevelServer(),
                energy_level: UserEnergy.getInstance().getAvaliableEnergy()[0],
                max_energy_level: UserEnergy.getInstance().getEnergyLimit(),
                infinite_energy: UserEnergy.getInstance().getEnergyInfinity()[0],
                goldcoin_hold: UserCash.getInstance().getAvaliableCash(),
                silvercoin_hold: UserCoin.getInstance().getAvaliableCoin(),
                refresh_hold: getPropHold(GamePropIds.kRefresh),
                stepback_hold: 0,
                exchange_hold: getPropHold(GamePropIds.kSwap),
                fivesteps_hold: getPropHold(GamePropIds.kAdd5),
                brush_hold: 0,
                hammer_hold: 0,
                sml_ebottle_hold: getPropHold(GamePropIds.kEnergy1),
                med_ebottle_hold: getPropHold(GamePropIds.kEnergy2),
                big_ebottle_hold: getPropHold(GamePropIds.kEnergy3),
                login_days: UserManager.getInstance().continueLoginDays,
                star_main_level: totalStar,
                star_ratio_main_level:  Math.round(totalStar / IslandBookManager.prototype.getTotalMaxStar.call(null) * 100) * 0.01,
                star_hid_level: 0,
                star_ratio_hid_level: 0,
                friend_num: UserManager.getInstance().getUserRef().friendNum,
                rank_in_friends: 0,
                levels_played_for_friends: 0,
                levels_played_by_friends: 0,
                promotional_campaign_ID: 0,
                promotional_campaign_data: null,
                uid: UserManager.getInstance().uid,
                udid: META.user.openid,
                keyt: "",
                carrier: 0,
                clienttype: device.clientType,
                clientpixel: device.clientPixel,
                platform: window.mini ? mini.getPlatform() : META.user.platform,
                gameversion: META.version,
                gender: 0,
                reg_time: UserManager.getInstance().createTime,
                country: location && location.country ,
                province: location && location.province,
                city: location && location.city,
                network_type: netType2Rtuf(self._netType),
                current_time: Localhost.time(),
                time_zone: "+08:00",
                weekend: day == 0 || day == 6,
                target_completion_percentage: 0,
                play_type: "main_level"
            },
            dcsessionID: dcUtil.getDCSession(),
            seqID: dcUtil.stealSeq(),
            dcLevel: UserManager.getInstance().getUserRef().topLevelId,
        }
    };
    if (packageType){
        param.type = packageType;
    }
    if (!param.aiRequest.rtuf.country) {
        param.aiRequest.rtuf.country = "unknown"
        window.logCenter && logCenter.error(new Error("AI Package country is null."), "AIPkgError");
    }
    if (!param.aiRequest.rtuf.province) {
        param.aiRequest.rtuf.province = "unknown"
    }
    if (!param.aiRequest.rtuf.city) {
        param.aiRequest.rtuf.city = "unknown"
    }

    // 填充关卡数据
    if (levelData) {
        param.aiRequest.levelId = levelData.levelID;
        param.aiRequest.rtuf.target_completion_percentage = levelData.targetPercent;
    } else {
        param.aiRequest.levelId = UserManager.getInstance().getUserRef().topLevelId;
        param.aiRequest.rtuf.target_completion_percentage = 0;
    }
    param.aiRequest.rtuf.level_version = param.aiRequest.levelId > 0 ? ResManager.getLevelMd5(param.aiRequest.levelId) : "";

    return param;
}

/**
 * 计算道具持有数量
 * @param {*} propId 道具所对应的持有化道具Id
 */
function getPropHold(propId) {
    switch (propId) {
        case GamePropIds.kRefresh:
            return UserProp.getInstance().getPropNumber(GamePropIds.kRefresh)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kRefresh_l)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kRefresh_t)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kRefresh_ad)[0];
        case GamePropIds.kSwap:
            return UserProp.getInstance().getPropNumber(GamePropIds.kSwap)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kSwap_l)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kSwap_t)[0];
        case GamePropIds.kAdd5:
            return UserProp.getInstance().getPropNumber(GamePropIds.kAdd5)[0]
                + UserProp.getInstance().getPropNumber(GamePropIds.kAdd5_s)[0];
        default:
            return UserProp.getInstance().getPropNumber(propId)[0];
    }
}

/**
 * 包装每日礼包数据
 * @param {*} serverData 
 */
function parseDailyPkg(self, serverData) {
    // 测试代码，用于浏览器查看全部每日礼包的布局
    if(__DEV) {
        const DebugValues = [
            {10006:99, 10001:99,10051:99, 10003:99,10004:99,10005:99},        
            {10006:99, 10001:99,10051:99, 10003:99,10004:99},        
            {10006:99, 10001:99,10051:99, 10003:99},        
            {10006:99, 10001:99,10051:99},        
            {10006:99, 10001:99},        
            {10006:99},
            {14:9999},
            {14:9999, 10001:99,10051:99, 10003:99,10004:99,10005:99}, 
            {14:9999, 10001:99,10051:99, 10003:99,10004:99}, 
            {14:9999, 10001:99,10051:99, 10003:99}, 
            {14:9999, 10001:99,10051:99}, 
            {14:9999, 10001:99}, 
            {14:9999, 2:999999}, 
            {14:9999, 2:999999,10001:99}, 
        ]
        let _debugAiDailyDebugIndex = localStorage.getItem("_debugAiDailyDebugIndex");
        _debugAiDailyDebugIndex = string2Number(_debugAiDailyDebugIndex, 0);
        serverData = {
            giftBagId: [0, 6000300],
            endTime: Localhost.time() + 3.1 * 60 * 60 * 1000
        }
        self.config.packages[serverData.giftBagId[1]].items = DebugValues[_debugAiDailyDebugIndex];
        _debugAiDailyDebugIndex = _debugAiDailyDebugIndex + 1;
        if (_debugAiDailyDebugIndex >= DebugValues.length)
            _debugAiDailyDebugIndex = 0;
        localStorage.setItem("_debugAiDailyDebugIndex", _debugAiDailyDebugIndex)
    }
    if (!serverData)
        return null;
    
    let packageId = serverData.giftBagId && serverData.giftBagId[1];
    let packageAI = serverData.giftBagInfo;
    let period = string2Number(serverData.endTime, 0);

    let pkgCfg = self.config.packages[packageId];
    if(!pkgCfg) {
        cc.warn("[AI Package]", "no package in config. daily packageId=", packageId);
        return null;
    }
    if(period <= Localhost.time()) {
        cc.warn("[AI Package]", "daily package: out of period.", period);
        return null;
    }
    
    let data = Object.assign(
        {
            // 这三个值只用于打点
            aiAlg: packageAI && packageAI.fspAlgorithmId || "",
            aiEvt: packageAI && packageAI.fspEventId || "",
            aiRec: packageAI && getRecPackageDCStr(packageAI.recPackages),

            // 过期时间戳
            period,
        },
        pkgCfg
    );
    
    // 填充礼包，进行一些检查以及折扣等信息的计算    
    let errList = fillCommonParam4Pkg(data);
    return errList.length > 0? null: data;
}

/**
 * 包装复活礼包列表
 * @param {*} self 
 * @param {*} serverData 
 */
function parseRevivePkg(self, serverData) {
    // 测试代码，用于浏览器查看全部关末礼包的布局
    if(__DEV) {
        serverData = {
            giftBagId:[0, 6000301,6000302,6000303, 6000304,6000305,6000306,6000307,6000308,6000309,6000310,6000311,6000312,6000313,6000314]
        }
        let _debugItems = [
            null, 
            {10006:99, 10001:99,10051:99, 10003:99,10004:99,10005:99},        
            {10006:99, 10001:99,10051:99, 10003:99,10004:99},        
            {10006:99, 10001:99,10051:99, 10003:99},        
            {10006:99, 10001:99,10051:99},        
            {10006:99, 10001:99},        
            {10006:99},
            {14:9999},
            {14:9999, 10001:99,10051:99, 10003:99,10004:99,10005:99}, 
            {14:9999, 10001:99,10051:99, 10003:99,10004:99}, 
            {14:9999, 10001:99,10051:99, 10003:99}, 
            {14:9999, 10001:99,10051:99}, 
            {14:9999, 10001:99}, 
            {14:9999, 2:999999}, 
            {14:9999, 2:999999,10001:99}, 
        ];
        for(let i = 1; i < serverData.giftBagId.length;i++) {
            self.config.packages[serverData.giftBagId[i]].items = _debugItems[i];
        }
    }
    if (!serverData)
        return null;

    let packageIds = serverData.giftBagId;
    let packageAI = serverData.giftBagInfo;
    if (!packageIds)
        return;

    let list = [], pkgCfg = null, packageData = null, errList = null;
    for(let i = 1; i <= $len(packageIds); i++) {
        pkgCfg = self.config.packages[packageIds[i]];
        if(!pkgCfg) {
            cc.warn("[AI Package]", "no package in config. revive packageId=", packageIds[i]);
            continue;
        }
        if (self._dailyPkg && self._dailyPkg.package_id == pkgCfg.package_id) {
            cc.warn("[AI Package]", "revive package is as same as daily package.packageId=", packageIds[i]);
            continue;
        }
        
        packageData = Object.assign({}, pkgCfg);
        errList = fillCommonParam4Pkg(packageData);
        if (errList.length === 0) {
            list.push(packageData);
        }
    }
    let data = {
        // 这三个值只用于打点
        aiAlg: packageAI && packageAI.fspAlgorithmId || "",
        aiEvt: packageAI && packageAI.fspEventId || "",
        aiRec: packageAI && getRecPackageDCStr(packageAI.recPackages),

        list
    };
    
    return data;
}

/**
 * 为礼包填充一些通用字段
 * 如果增加风车币支付的礼包，可以在这里对价格进行一下处理
 * @param {*} packageData 一个已经包装好的礼包数据，包含h5_ai礼包配置中的字段 
 */
function fillCommonParam4Pkg(packageData) {
    packageData.payType = AIPayType.RMB;
    packageData.payPrice = packageData.rmb / 100;   // 用于显示的价格，现金为元
    packageData.dcPrice = string.format("%.2f", packageData.payPrice);  // 打点价格保留两位小数

    let packageId = packageData.package_id;
    // 计算总价值
    let value = 0, propMeta = null, cashCount = 0, otherCount = 0, errList = [], key = null;
    let keys = Object.keys(packageData.items);

    for(let i = 0; i < keys.length; i++) {
        key = keys[i];
        propMeta = MetaManager.getPropMeta(key);
        
        if (!propMeta) {
            errList.push(`packageId=${packageId}.err= failed to find prop in meta! itemId=${key}!`);
        } else {
            if (key == GamePropIds.kCash) {
                cashCount = cashCount + 1;
            } else {
                otherCount = otherCount + 1;
            }

            value = value + (propMeta.displayPrice? string2Number(propMeta.displayPrice, 0): string2Number(propMeta.price, 0)) * packageData.items[key];
        }
    }

    packageData.realValue = value;
    let discount = packageData.payPrice * 100 / packageData.realValue;
    let discountStr = null;
    if (discount >= 1) {
        discountStr = Math.floor(discount).toString();
        if (discountStr.length > 1) 
            discountStr = null;
    } else {
        discountStr = string.format("%.1f", Math.floor(discount * 10) * 0.1);
        if (discountStr === "0.0")
            discountStr = "0.1"
    }
    packageData.discountStr = discountStr;

    // 进行一次礼包内容数量校验
    if (cashCount > 1) {
        errList.push(`packageId=${packageId}.err= too many happycoins in package!`);
    } 
    if (cashCount + otherCount > 6) {
        errList.push(`packageId=${packageId}.err= too many items in package!`);
    }

    if (errList.length > 0) {
        cc.error("[AI Package]", "ai-package is invaild.", errList);
        window.logCenter && logCenter.error(new Error(`ai-package is invaild. error=${errList.join(";")}`), 'AIPkgError');
    }
    
    return errList;
}

function readStorage() {
    let s = cc.sys.localStorage.getItem(STORAGE_KEY);
    if (s) {
        try {
            s = JSON.parse(s);
            if (s.ver != STORAGE_VER)
                s = null;
        } catch (e) {
            s = null;
        }
    }

    if (!s) {
        s = {
            ver: STORAGE_VER,   // 缓存格式版本号
            lastDailyPop: 0,    // 上一次弹出每日特惠礼包的日期零点
        }
    }
    return s;
}

function writeStorage(storage) {
    cc.sys.localStorage.setItem(STORAGE_KEY, JSON.stringify(storage));
}

/**
 * 将游戏内的netType转为实时特征值格式的network_type
 * Wifi or data connection int (-1:none,0:data,2:WIFI)
 * @param {*} newType 
 */
function netType2Rtuf(netType) {
    netType = netType && netType.toLowerCase();
    switch (netType) {
        case "none":
            return "-1";
        case "wifi":
            return "2";
        default:
            return "0";
    }
}

function string2Number(str, defaultValue) {
    let i = str * 1;
    return isNaN(i)? defaultValue: i;
}

/**
 * 包装用于打点recPackages的id信息，以_分割
 * @param {*} recPackages 
 */
function getRecPackageDCStr(recPackages) {
    if (recPackages) {
        let ids = [];
        for(let i = 0; i <= $len(recPackages); i++) {
            if (recPackages[i])
                ids.push(recPackages[i].packageId);
        }
        return ids.join("_");
    } 
    return "";
}

/**
 * 获取正交分组信息
 */
function loadTestGroupInfoPromise() {
    return new Promise((resolve, reject)=> {
        let http = AIGetGroupTestHttp.new();

        http.addEventListener(Events.kComplete, resolve);
        http.addEventListener(Events.kError, reject);
        http.addEventListener(Events.kCancel, reject);
        http.load();
    })
}
/**
 * 收集玩家ai礼包实时特征值
 */
AIPkgManager.prototype.collectUserAiInfo = function () {
    cc.log("[AI Package]", "collectUserAiInfo start...");
    let self = this;
    let offsetTime =  new Date().getTime() - self.collectUserAiStartTime;
    if (!self.collectUserAiStartTime || offsetTime < AI_DELAY_TIME ){
        cc.log("[AI Package]", `collectUserAiInfo wait time offsetTime < ${AI_DELAY_TIME}...`,offsetTime);
        return;
    }
    let param = packGetReq(self);
    cc.log("[AI Package]", "collectUserAiInfo param...",param);
    let http = AICollectUserInfoHttp.new();
    let retryNum = 0;
    const RETRY_MAX_NUM = 3;//重试次数最大上限

    function onFail(evt) {
        cc.warn("[AI Package]", "request ai collectUserAiInfo failed.", evt);
        if (retryNum < RETRY_MAX_NUM){
            retryNum++;
            cc.log("[AI Package]", "request ai collectUserAiInfo retryNum.", retryNum);
            http.load(param);
        }else{
            cc.warn("[AI Package]", "request ai collectUserAiInfo retry reach limit ,stop retry");

        }
    }
    function onSuccess(evt) {
        cc.log("[AI Package]", "ai collectUserAiInfo success.", evt);

    }

    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);

    http.load(param);
}
/** 获取ai礼包id对应的a组id */
AIPkgManager.prototype.getLeaderId = function(id) {
    let package_id = id;
    if(package_id > 7000000) {
        package_id -= 1000000;
    }
    return package_id;
}

AIPkgManager.prototype.getCube = function() {
   return this.dailyBindGiftAbGroup || "a";
}

module.exports = AIPkgManager